import { defineMessages } from 'react-intl';

export const messages: {
	entitiesIndexedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	relationshipsCreatedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	queriesThisWeekLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	customersUsingLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headlineLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contextBuiltYourWayTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contextBuiltYourWayDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aiReadyDataTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aiReadyDataDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contextThatTravelsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contextThatTravelsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	graphVisualizationAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	entitiesIndexedLabel: {
		id: 'twg-microsite.overviewSection.entitiesIndexed.label',
		defaultMessage: 'Entities\nindexed',
		description:
			'Two-line uppercase label above the count of entities indexed in the graph. The newline is intentional and is rendered as a hard line break.',
	},
	relationshipsCreatedLabel: {
		id: 'twg-microsite.overviewSection.relationshipsCreated.label',
		defaultMessage: 'Relationships\ncreated',
		description:
			'Two-line uppercase label above the count of relationships created in the graph. The newline is intentional and is rendered as a hard line break.',
	},
	queriesThisWeekLabel: {
		id: 'twg-microsite.overviewSection.queriesThisWeek.label',
		defaultMessage: 'Queries\nthis week',
		description:
			'Two-line uppercase label above the count of queries run against the graph this week. The newline is intentional and is rendered as a hard line break.',
	},
	customersUsingLabel: {
		id: 'twg-microsite.overviewSection.customersUsing.label',
		defaultMessage: 'Customers\nusing',
		description:
			'Two-line uppercase label above the count of customers using the graph. The newline is intentional and is rendered as a hard line break.',
	},
	headlineLabel: {
		id: 'twg-microsite.overviewSection.headline.label',
		defaultMessage: 'Headline',
		description:
			'Small uppercase eyebrow label that sits above each value-pillar card title. Placeholder copy that will be refined per pillar in a later iteration.',
	},
	contextBuiltYourWayTitle: {
		id: 'twg-microsite.overviewSection.contextBuiltYourWay.title',
		defaultMessage: 'Context, built your way',
		description:
			'Title of the value-pillar card about customising context via connectors and APIs.',
	},
	contextBuiltYourWayDescription: {
		id: 'twg-microsite.overviewSection.contextBuiltYourWay.description',
		defaultMessage:
			'{twg_branding} connectors and APIs make it easy to bring in any tool and customize how your context gets surfaced.',
		description:
			'Description of the value-pillar card about customising context via connectors and APIs. {twg_branding} is the product brand name.',
	},
	aiReadyDataTitle: {
		id: 'twg-microsite.overviewSection.aiReadyData.title',
		defaultMessage: 'Get AI-ready data without the work',
		description: 'Title of the value-pillar card about pre-structured, AI-ready data.',
	},
	aiReadyDataDescription: {
		id: 'twg-microsite.overviewSection.aiReadyData.description',
		defaultMessage:
			'{twg_branding} delivers structure, pre-defined relationships, giving AI clients exactly what they need. That means sharper responses, faster and cheaper.',
		description:
			'Description of the value-pillar card about pre-structured, AI-ready data. {twg_branding} is the product brand name.',
	},
	contextThatTravelsTitle: {
		id: 'twg-microsite.overviewSection.contextThatTravels.title',
		defaultMessage: 'Context that travels with you',
		description: 'Title of the value-pillar card about context being available across AI clients.',
	},
	contextThatTravelsDescription: {
		id: 'twg-microsite.overviewSection.contextThatTravels.description',
		defaultMessage:
			'No matter which AI client or modality you prefer, {twg_branding} brings your full context to where you work. No more tab-switching.',
		description:
			'Description of the value-pillar card about context being available across AI clients. {twg_branding} is the product brand name.',
	},
	graphVisualizationAlt: {
		id: 'twg-microsite.overviewSection.graphVisualization.alt',
		defaultMessage: 'A visualization of nodes connected in the {twg_branding}.',
		description:
			'Alt text describing the decorative graph visualization image that appears beside the value-pillar cards. {twg_branding} is the product brand name.',
	},
});
